module.exports = __webpack_public_path__ + "img/google-maps-platform-svgrepo-com.c5f8793e.svg";